let request;
const body = $('body');
const ajax = $('.ajax');
const ajaxButtonLoadMore = ajax.find('.js-load-more');
const favorites = $('#favorites');

const ajaxSendData = function (container) {
    if (request) {
        request.abort();
    }

    request = $.ajax({
        url: fw.ajax,
        type: 'POST',
        data: fw.data
    });

    //console.log(fw.data);

    container.trigger('ajax__run');

    request
        .done(function (responseJSON, textStatus, jqXHR) {
            let response = JSON.parse(responseJSON);
            let action = response.action;

            if (0 === response.code) {
                container.trigger(action, response);

                if (1 === response.eof) {
                    container.trigger('ajax__eof', response);
                }
            } else {
                container.trigger(action, response);
            }
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.error(
                'The following error occurred: ' +
                textStatus, errorThrown
            );
        })
        .always(function () {
            container.trigger('ajax__end');
        });
};

const ajaxInsertPosts = function (container, posts) {
    let containerLoadPoint = container.find('.load-more');

    if (!containerLoadPoint.length) {
        return;
    }

    posts.each(function () {
        $(this).addClass('ajax__hidden').css({
            opacity: 0
        });
    });

    posts.insertBefore(containerLoadPoint);

    posts.each(function (i) {
        let button = $(this).find('.js-favorites-button');
        handleFavoriteButtonClick(button);
    });

    let currentTime = 0;
    let stepTime = 50;

    container.find('.ajax__hidden').each(function () {
        (function (which, currentTime) {

            setTimeout(function () {
                which.removeClass('ajax__hidden').animate({
                    opacity: 1
                }, 50)
            }, currentTime);

        })($(this), currentTime);

        currentTime += stepTime;
    });
}

const ajaxSubscribeEmail = function (target) {
    let ajaxContainerData = fw.data;
    if (!ajaxContainerData) return;

    // Запоминаем основной action, прежде, чем его сменить
    let _action = ajaxContainerData.action;
    ajaxContainerData.action = 'subscribe_email';
    ajaxContainerData.email = target.find('[name="email"]').val();

    ajaxSendData(target);

    // Восстанавливаем action по-умолчанию
    ajaxContainerData.action = _action;
}

const ajaxSendFavorites = function (button) {
    let ajaxContainerData = fw.data;
    if (!ajaxContainerData) return;

    // Запоминаем основной action, прежде, чем его сменить
    let _action = ajaxContainerData.action;
    ajaxContainerData.action = 'toggle_favorites';
    ajaxContainerData.item_id = button.data('post-id') || 0;

    ajaxSendData(favorites);

    // Восстанавливаем action по-умолчанию
    ajaxContainerData.action = _action;
}

const handleMobileMenuToggleClick = function () {
    $('.nav-toggle').on('click', function (e) {
        const navState = parseInt(body.attr('data-nav-state'));
        body.attr('data-nav-state', +!navState);
        body.attr('data-search-form-state', 0);

        e.preventDefault();
    });
}

const handleSearchFormToggleClick = function () {
    $('.search-toggle').on('click', function (e) {
        const navState = parseInt(body.attr('data-search-form-state'));
        body.attr('data-search-form-state', +!navState);
        body.attr('data-nav-state', 0);

        e.preventDefault();
    });
}

const handleSearchCloseClick = function () {
    $('.js-search-close').on('click', function (e) {
        const inputSearch = $(this).siblings('input[type="search"]');
        if ('' !== inputSearch.val()) {
            inputSearch.val('');
        } else {
            body.attr('data-search-form-state', 0);
        }

        e.preventDefault();
    })
}

const splashFormMessage = function (form, message) {
    let label = form.find('.form__label-message');

    label.text(message);
    label.addClass('form__label-message_active');

    setTimeout(function () {
        label.removeClass('form__label-message_active');
    }, 3000);

    setTimeout(function () {
        label.text('');
    }, 3400);
}

const handleFormSubscribe = function () {
    $('.js-subscribe-form').each(function () {
        let form = $(this);

        form.on('submit', function (e) {
            ajaxSubscribeEmail(form);

            e.preventDefault();
        });

        form.on('subscribe__success', function (event, message) {
            form.find('[name="email"]').val('');
            splashFormMessage(form, message.data);
        });

        form.on('subscribe__error', function (event, message) {
            splashFormMessage(form, message.data);
        });
    });
}

const handleFavoriteButtonClick = function (button) {
    button.on('click', function (e) {
        ajaxSendFavorites($(this));

        e.preventDefault();
    });
}

const handleFavoriteButtonsClick = function () {
    $('.js-favorites-button').each(function (i) {
        handleFavoriteButtonClick($(this));
    });
}

const handleFavoriteAjaxResponse = function () {
    favorites.on('favorite__success', function (event, response) {
        let postId = response.data;

        let button = $('.js-favorites-button[data-post-id="' + postId + '"]');

        if (button.length) {
            button.attr('data-is-in-favorites', response.state);

            if (0 === response.state && 'favorites' === body.data('page-name')) {
                let card = button.closest('.card');
                card.fadeOut(400);

                setTimeout(function () {
                    card.remove();
                }, 400);
            }
        }
    });

    favorites.on('favorite__error', function (event, response) {
        if (401 === response.code) {
            window.location.href = response.data;
        } else {
            console.log(response);
        }
    });

}

const handleLoadMoreButtonClick = function () {
    if (!ajaxButtonLoadMore.length) {
        return;
    }

    ajaxButtonLoadMore.on('click', function (e) {
        let el = $(this);
        let ajaxContainerData = fw.data;

        if (!ajaxContainerData) return;

        let page = ajaxContainerData.args.paged || 1;
        ajaxContainerData.args.paged = page + 1;

        ajaxSendData(ajax);

        e.preventDefault();
    });
}

const handleLoadMoreAjaxResponse = function () {
    ajax.on('ajax__eof', function (event, response) {
        let posts = $(response.data);

        ajaxInsertPosts(ajax, posts);

        ajaxButtonLoadMore.parent().fadeOut(400);
    });

    ajax.on('ajax__success', function (event, response) {
        let posts = $(response.data);

        ajaxInsertPosts(ajax, posts);
    });

    ajax.on('ajax__error', function (event, response) {
        console.log(response.message);
    });
}

const handlePopupSubscribeForm = function () {
    if ($('#subscribe').length) {
        setTimeout(function () {
            $.magnificPopup.open({
                items: {src: '#subscribe'},
                type: 'inline',
                preloader: false,
                focus: 'input[type="email"]',
                closeOnContentClick: false,
                closeBtnInside: true,
                fixedContentPos: true,
                mainClass: 'mfp-fade',
                removalDelay: 300,
                overflowX: true,
                closeMarkup: '<a class="mfp-close subscribe-popup__close icon icon-close"></a>'
            }, 0);
        }, 1000);
    }
}

const handleMagnificPopupContentImagesClick = function () {
    if ('post' !== body.data('page-type')) {
        return;
    }

    $('.js-popup, .wp-block-image a').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        closeBtnInside: false,
        fixedContentPos: false,
        mainClass: 'mfp-fade',
        removalDelay: 300,
        overflowX: true,
        image: {
            verticalFit: true
        }
    });
}

const handleContentImagesLayout = function () {
    if ('post' !== body.data('page-type')) {
        return;
    }

    $('.content img').each(function (i) {
        let img = $(this);
        let imgSrc = img.attr('src');
        let imgFigure = img.closest('figure');
        let imgCaptionText = '';

        if (imgFigure.length) {
            let imgCaption = imgFigure.find('figcaption');

            if (imgCaption.length) {
                imgCaptionText = imgCaption.text();
            }
        } else {
            if (img.hasClass('alignleft')) {
                img.wrap('<figure class="content__figure alignleft" />');
                img.removeClass('alignleft');
            } else if (img.hasClass('alignright')) {
                img.wrap('<figure class="content__figure alignright" />');
                img.removeClass('alignright');
            } else {
                img.wrap('<figure class="content__figure alignnone" />');
                img.removeClass('alignnone');
            }
        }

        //img.closest('figure').css({
        //    'max-width': $(window).width() - 50
        //});

        if (!img.closest('a').length) {
            img.wrap('<a href="' + imgSrc + '" class="content__image js-popup" title="' + imgCaptionText + '"></a>')
        }
    });

    $('.alignleft + .alignright').each(function () {
        $(this).prev().addBack().wrapAll('<div class="content__image-double" />');
    });
}

$(window).on('load', () => {
    $('html').removeClass('no-js').addClass('js');
    handleContentImagesLayout();
    handleMobileMenuToggleClick();
    handleSearchFormToggleClick();
    handleSearchCloseClick();
    handleLoadMoreButtonClick();
    handleLoadMoreAjaxResponse();
    handleFormSubscribe();
    handlePopupSubscribeForm();
    handleFavoriteButtonsClick();
    handleFavoriteAjaxResponse();
    handleMagnificPopupContentImagesClick();

    // Костыль, убрать после покупки плагина авторизации
    if ($('.nsl-container').length) {
        $('.nsl-container').each(function (i) {
            $(this).attr('data-align', 'center');
        });
    }
});
